import React, { Component } from "react"
import "./Headline.scss"

class Headline extends Component {
    render() {
        return (
            <section className="section section-headline">
                <div className="padding">
                    <div className="container">
                        <div className="imagehead"></div>
                        <div className="headline">
                            שחקני נשמה
                        </div>
                        <div className="separator"></div>
                        <div className="desc">
                            <span>
                                עמדתם שעתיים מול חלון ראווה של חנות טלוויזיות?
                        <span className="brdesktop"><br /></span> התנחלתם באיזה קפה אינטרנט דלוח בהודו?</span>
                            <br />
                            ספרו לנו על הדברים המטורפים והקיצוניים ביותר שעשיתם בשביל לצפות במשחק מהמונדיאל, ואנחנו נבחר את הכי מקוריים ונפנק אותם ב-300 ₪ לקניות באתר <strong>BringBring סופרמרקט אונליין</strong>.
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default Headline;


// WEBPACK FOOTER //
// ./src/Components/Body/Headline.jsx